import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from "./ParticlesAuth";
import CryptoJS from 'crypto-js';

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link } from "react-router-dom";
import logoLight from "../../assets/images/logo-light.png";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { postDataAPI } from "../../helpers/phpbackend_helper";

// actions
import { loginUser, resetRegisterFlag } from "../../store/actions";
import { getStorageKey, loadAttemptData } from '../../common/loginAttemptManager';
import CookieBanner from "../../Components/Common/CookieBanner";

// Constants
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const Login = (props) => {

    const dispatch = useDispatch();
    const [passwordShow, setPasswordShow] = useState(false);
    const [ssoLoading, setSsoLoading] = useState(false);
    const [hidePassword, setHidePassword] = useState(true);
    const [isBlocked, setIsBlocked] = useState(false);
    const [remainingTime, setRemainingTime] = useState(0);
    let countdownInterval = null;
    const [recaptchaError, setRecaptchaError] = useState("");
    
    useEffect(() => {
        dispatch(resetRegisterFlag());
        checkBlockStatus();
    }, [dispatch]);
    

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email:  '',
            password: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: async (values) => {
            try {
                const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

                if (!window.grecaptcha) {
                    console.error("reCAPTCHA not loaded.");
                    alert("reCAPTCHA not loaded yet. Please wait a few seconds and try again.");
                    return;
                }

                if (!siteKey) {
                    console.error("reCAPTCHA site key is missing.");
                    alert("Login temporarily unavailable. Please contact support.");
                    return;
                }

                // Wait until reCAPTCHA script is ready
                await window.grecaptcha.ready(async () => {
                try {
                    const token = await window.grecaptcha.execute(siteKey, { action: "login" });

                    if (!token) {
                        console.error("No reCAPTCHA token received.");
                        alert("reCAPTCHA verification failed. Please refresh and try again.");
                        return;
                    }

                    // ✅ Add token to your login payload
                    const loginPayload = {
                        ...values,
                        recaptcha_token: token,
                    };

                    // ✅ Now dispatch login only if captcha passed
                    dispatch(loginUser(loginPayload, props.history));

                } catch (innerErr) {
                    console.error("reCAPTCHA execution error:", innerErr);
                    alert("Unable to verify reCAPTCHA. Please try again later.");
                }
                });

            } catch (err) {
                console.error("Unexpected error in reCAPTCHA:", err);
                alert("Something went wrong. Please try again.");
            }
        }

    });


const checkBlockStatus = () => {
  const attemptData = loadAttemptData(getStorageKey());
  if (attemptData && attemptData.blockedUntil) {
    const now = Date.now();
    if (now < attemptData.blockedUntil) {
      setIsBlocked(true);
      const remaining = Math.floor((attemptData.blockedUntil - now) / 1000);
      setRemainingTime(remaining);
      startCountdown(attemptData.blockedUntil);
    } else {
      localStorage.removeItem(getStorageKey());
      setIsBlocked(false);
    }
  }
};

const startCountdown = (blockedUntil) => {
  clearInterval(countdownInterval); // Clear any previous interval

  countdownInterval = setInterval(() => {
    const now = Date.now();
    const remaining = Math.floor((blockedUntil - now) / 1000);

    if (remaining <= 0) {
      clearInterval(countdownInterval);
      setIsBlocked(false);
           localStorage.removeItem(getStorageKey());

    } else {
      setRemainingTime(remaining);
    }
  }, 1000);
};

  // ✅ Format seconds to MM:SS
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

    const handleSSOCheck = () =>{
        setSsoLoading(true);
        postDataAPI({
            serviceName: "user_sso",
            op: "sso_login",
            uname: validation.values.email
          }).then((response) => {
            setSsoLoading(false);
            if (response.status === "ok") {
                if(response.data.user_type=="normal user"){
                    setHidePassword(false);
                }else{
                    window.location.href=response.data.sso_url;
                }
            } else {
                console.log(response);
            }
          });
    }

    const { error,isApiLoading } = useSelector(state => ({
        error: state.Login.error,
        isApiLoading:state.Login.loading,
    }));
    document.title = "Sign in | "+process.env.REACT_APP_NAME;
    
    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-4 mb-4 text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                        <img src={logoLight} className="img-fluid" alt={process.env.REACT_APP_SMALL_NAME} width="180"/>
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4">
                                    <CardBody className="p-4">
                                         {isBlocked ? (
                      <div className="text-center">
                        <h5 className="text-danger">🚫 Too Many Failed Attempts</h5>
                        <p className="text-muted">
                          You are blocked for {process.env.REACT_APP_LOGINATTEMPT} minutes.<br />
                          Try again in: <strong>{formatTime(remainingTime)}</strong>
                        </p>
                      </div>
                    ) : (<>  <div className="text-center mt-2">
                                            <h5 className="text-primary">Welcome Back !</h5>
                                            <p className="text-muted">Sign in to continue to {process.env.REACT_APP_NAME}.</p>
                                        </div>
                                        {error && <Alert color="danger">{error}</Alert>}
                                        {recaptchaError && <Alert color="warning">{recaptchaError}</Alert>} {/* ✅ NEW */}
                                        <div className="p-2 mt-4">
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                                action="#">

                                                <div className="mb-3">
                                                    <Label htmlFor="email" className="form-label">Email</Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={
                                                            validation.touched.email && validation.errors.email ? true : false
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                    ) : null}
                                                </div>
                                                {hidePassword? <>
                                                    <div className="mt-4">
                                                        <Button onClick={handleSSOCheck} color="success" className="btn btn-success w-100" type="button" disabled={ssoLoading}>Next <Spinner className={ssoLoading ? "ms-1" : "ms-1 invisible"} size="sm"></Spinner></Button>
                                                    </div>
                                                </> : <>
                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                                                    </div>
                                                    <Label className="form-label" htmlFor="password-input">Password</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input                                                        
                                                            // autoComplete="new-password"
                                                            name="password"
                                                            value={validation.values.password || ""}
                                                            type={passwordShow ? "text" : "password"}
                                                            className="form-control pe-5"
                                                            placeholder="Enter Password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                validation.touched.password && validation.errors.password ? true : false
                                                            }
                                                        />
                                                        {validation.touched.password && validation.errors.password ? (
                                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                        ) : null}
                                                        <Button color="link" onClick={() => setPasswordShow(!passwordShow)} className="position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button"
                                                        id="password-addon"><i className="ri-eye-fill align-middle"></i></Button>
                                                    </div>
                                                </div>
                                                <div className="form-check">
                                                    <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                    <Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
                                                </div>

                                                <div className="mt-4">
                                                    <Button color="success" className="btn btn-success w-100" type="submit" disabled={isApiLoading}>Sign In <Spinner className={isApiLoading ? "ms-1" : "ms-1 invisible"} size="sm"></Spinner> </Button>
                                                </div>
                                                </>
                                                }
                                            </Form>
                                        </div></>)}
                                      
                                    </CardBody>
                                </Card>
                                
                                {/* {!isBlocked &&
                                <div className="mt-4 text-center">
                                    <p className="mb-0">Don't have an account ? <Link to="/register" className="fw-semibold text-primary text-decoration-underline"> Signup </Link> </p>
                                </div>
                                }                                 */}
                            </Col>
                            <CookieBanner />
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);